import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=da4bd5de&scoped=true"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"
import style0 from "./CustomerList.vue?vue&type=style&index=0&id=da4bd5de&prod&lang=scss&scoped=true"
import style1 from "./CustomerList.vue?vue&type=style&index=1&id=da4bd5de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4bd5de",
  null
  
)

export default component.exports